(() => {
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-rv-guarantee]');
    const dialog = document.getElementById('rv-guarantee-dialog');
    if (!trigger || !dialog || typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    dialog.showModal();
    document.body.classList.add('rv-modal-open');
  });
  const dialog = document.getElementById('rv-guarantee-dialog');
  if (!dialog) return;
  dialog.addEventListener('close', () => document.body.classList.remove('rv-modal-open'));
  dialog.addEventListener('click', event => {if (event.target === dialog) dialog.close();});
})();
